import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField } from '@mui/material';
import { DEFAULT_MARMIN_API_VERSION } from '../constants/connectorsApi';
import appConfig from '../../../config/appConfig';
import { isValidConnectorKey, normalizeConnectorKey } from '../utils/connectorRouteUtils';

const CreateConnectorDialog = ({ open, onClose, onSubmit, isPending, targets, marminApiVersions }) => {
  const [key, setKey] = React.useState('');
  const [name, setName] = React.useState('');
  const [documentType, setDocumentType] = React.useState(targets[0] || 'marmin.sale.invoice');
  const [marminApiVersion, setMarminApiVersion] = React.useState(marminApiVersions[0] || DEFAULT_MARMIN_API_VERSION);

  const normalizedKey = normalizeConnectorKey(key);
  const keyError =
    key && !isValidConnectorKey(normalizedKey)
      ? 'Use lowercase letters, numbers, hyphens, or underscores (no spaces)'
      : '';

  const handleSubmit = () => {
    if (!isValidConnectorKey(normalizedKey)) {
      return;
    }

    onSubmit({
      key: normalizedKey,
      name,
      documentType,
      marminApiVersion,
    });
  };

  React.useEffect(() => {
    if (!open) {
      setKey('');
      setName('');
      setDocumentType(targets[0] || 'marmin.sale.invoice');
      setMarminApiVersion(marminApiVersions[0] || DEFAULT_MARMIN_API_VERSION);
    }
  }, [open, targets, marminApiVersions]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create connector</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            label="Connector key"
            value={key}
            onChange={(e) => setKey(normalizeConnectorKey(e.target.value))}
            helperText={keyError || 'Unique per org, e.g. xero-invoice (no spaces)'}
            error={Boolean(keyError)}
            required
            fullWidth
          />
          <TextField label="Display name" value={name} onChange={(e) => setName(e.target.value)} required fullWidth />
          <TextField
            select
            label="Document type"
            value={documentType}
            onChange={(e) => setDocumentType(e.target.value)}
            fullWidth
          >
            {targets.map((t) => (
              <MenuItem key={t} value={t}>
                {t}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label={`${appConfig.brandName} API version`}
            value={marminApiVersion}
            onChange={(e) => setMarminApiVersion(e.target.value)}
            fullWidth
          >
            {marminApiVersions.map((v) => (
              <MenuItem key={v} value={v}>
                {v}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!normalizedKey || !name || Boolean(keyError) || isPending}
          onClick={handleSubmit}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateConnectorDialog;
